import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../../../ParticipantsStore';
import ModalStore from '../../../../../../Modal/Store';
import ReclaimLicensesStore from '../../Store';
import Alert from './Alert';
import CancelButton from './Buttons/CancelButton';
import SubmitButton from './Buttons/SubmitButton';
import CheckedParticipantsList from './CheckedParticipantsList';

interface Props {
  participantsStore: ParticipantsStore;
  modalStore: ModalStore;
  reclaimLicensesStore: ReclaimLicensesStore;
}

function ReadyBody({ participantsStore, modalStore, reclaimLicensesStore }: Props) {
  return (
    <>
      <CheckedParticipantsList store={participantsStore} />
      <Alert participantsStore={participantsStore} />
      <div className="flex mt-4">
        <CancelButton modalStore={modalStore} store={reclaimLicensesStore} />
        <SubmitButton reclaimLicensesStore={reclaimLicensesStore} />
      </div>
    </>
  );
}

export default observer(ReadyBody);
